// extracted by mini-css-extract-plugin
export var container = "_fa-0";
export var icon = "_fa-1";
export var text = "_fa-2";